import { SectionTitle, SectionWrapper } from '@/components';
import breakpoint from '@/constants/theme/breakpoint';
import { useShipmentsOverviewContext } from '@/modules/pmt/context';
import { DefaultTrackingContainer } from '../DefaultTrackingContainer';
import { TrackingDetails } from '../TrackingDetails';
import { NoParcelsFoundPanel } from './components/NoParcelsFoundPanel';
import { useMyParcelsRightSectionCopy } from './hooks';

export const MyParcelsRightSection = () => {
  const { sectionTitleDesktop } = useMyParcelsRightSectionCopy();
  const { noShipmentsFound, noShipmentsAdded } = useShipmentsOverviewContext();

  if (noShipmentsAdded) {
    return (
      <SectionWrapper breakpoint={breakpoint.breakpointKeys.lg}>
        {sectionTitleDesktop && <SectionTitle>{sectionTitleDesktop}</SectionTitle>}
        <DefaultTrackingContainer />
      </SectionWrapper>
    );
  }

  if (noShipmentsFound) {
    return (
      <SectionWrapper breakpoint={breakpoint.breakpointKeys.lg}>
        <NoParcelsFoundPanel />
      </SectionWrapper>
    );
  }

  return <TrackingDetails />;
};
